import { combine, createEffect, createStore } from "effector"

import MaintenanceType from "models/MaintenanceType"
import AssetService from "services/AssetService"
import { Guid } from "@/types"

export const $maintenanceTypes = createStore<MaintenanceType[] | null>(null)

export const $maintenanceTypesMap = combine([
    $maintenanceTypes,
], ([maintenanceTypes]) => {
    const map = new Map<Guid, MaintenanceType>()
    maintenanceTypes?.forEach(mt => {
        map.set(mt.id, mt)
    })
    return map
})

export const fetchMaintenanceTypes = createEffect(async ({ ignoreCache }: { ignoreCache?: boolean } = {}) => {
    if (!ignoreCache) {
        const cache = $maintenanceTypes.getState()
        if (cache) return cache
    }
    return AssetService.getMaintenanceTypes()
})

export const $isFetchingMaintenanceTypes = combine([
    fetchMaintenanceTypes.inFlight,
], ([count]) => count > 0)

$maintenanceTypes.on(fetchMaintenanceTypes.doneData, (_, payload) => payload)
